import ZipcodeMap from "@/Pages/Auth/Settings/ZipCodes/ZipcodeMap";
import Modal, { ModalProps } from "../Modal/Modal";

const ZipcodeMapModal = ({ onExit, ...props }: ModalProps) => {
  return (
    <Modal width={{ _: "95%", sm: "60rem" }} onExit={onExit} {...props}>
      <div className="h-[75vh]">
        <ZipcodeMap />
      </div>
    </Modal>
  );
};

export default ZipcodeMapModal;
